console.log('🚀 Photo Form v2 - Chargé');

(() => {
  'use strict';

  const WEBHOOK_URL = "https://n8n.srv858071.hstgr.cloud/webhook/af8f17b3-4f2c-4b1a-9f06-57b63960c763";
  const MAX_BYTES = 10 * 1024 * 1024;

  let chosenFile = null;
  let blobUrl = null;
  let previewUrl = null;
  let isGenerating = false;

  function init() {
    const fileEl = document.getElementById('cbx-file');
    if (!fileEl) {
      setTimeout(init, 100);
      return;
    }
    console.log('✅ Initialisation');
    setup();
  }

  function setup() {
    const fileEl = document.getElementById('cbx-file');
    const chooseBtn = document.getElementById('cbx-choose');
    const uploadZone = document.querySelector('.upload-zone');
    const emptyState = document.getElementById('cbx-empty');
    const previewState = document.getElementById('cbx-preview');
    const thumb = document.getElementById('cbx-thumb');
    const fileName = document.getElementById('cbx-name');
    const uploadStatus = document.getElementById('cbx-upload-status');
    const clearBtn = document.getElementById('cbx-clear');
    const urlInput = document.getElementById('cbx-url');
    const statusEl = document.querySelector('.status-message');
    const addBtn = document.querySelector('.btn-add-cart');
    const dynamicPrice = document.getElementById('dynamic-price');

    const apSection = document.querySelector('.apercu-section');
    const apSkel = document.getElementById('ap-skel');
    const apImg = document.getElementById('ap-img');
    const apOrig = document.getElementById('ap-orig');
    const apShare = document.getElementById('ap-share');
    const apDL = document.getElementById('ap-download');

    const lb = document.getElementById('ap-lightbox');
    const lbImg = document.getElementById('ap-full');
    const lbBackdrop = lb?.querySelector('.lightbox-backdrop');
    const lbClose = lb?.querySelector('.lightbox-close');

    if (lb && lb.parentElement !== document.body) {
      document.body.appendChild(lb);
    }

    // Gestion Solo/Duo, prix dynamique et variantes
    const typeInputs = document.querySelectorAll('input[name="properties[Type]"]');
    const sizeInputs = document.querySelectorAll('input[name="properties[Taille]"]');
    const uploadDesc = document.getElementById('upload-desc');
    const mainForm = document.querySelector('form[data-type="add-to-cart-form"]');
    const variantInput = mainForm?.querySelector('input.product-variant-id, input[name="id"]');

    function getCurrentType() {
      const checkedType = document.querySelector('input[name="properties[Type]"]:checked');
      return checkedType?.dataset.type || 'solo';
    }

    function updateVariantAndPrice() {
      const type = getCurrentType();
      const isDuo = type === 'duo';
      const checkedSize = document.querySelector('input[name="properties[Taille]"]:checked');

      // Mettre à jour l'affichage des prix dans les cartes taille
      document.querySelectorAll('.size-card').forEach(card => {
        const soloPrice = card.querySelector('.price-solo');
        const duoPrice = card.querySelector('.price-duo');
        if (soloPrice) {
          soloPrice.classList.toggle('active', !isDuo);
        }
        if (duoPrice) {
          duoPrice.classList.toggle('active', isDuo);
        }
      });

      if (checkedSize) {
        // Mettre à jour le prix du bouton
        if (dynamicPrice) {
          const price = isDuo ? checkedSize.dataset.priceDuo : checkedSize.dataset.priceSolo;
          dynamicPrice.textContent = price;
          dynamicPrice.style.transform = 'scale(1.15)';
          setTimeout(() => dynamicPrice.style.transform = 'scale(1)', 200);
        }

        // Mettre à jour la variante Shopify
        const variantId = isDuo ? checkedSize.dataset.variantDuo : checkedSize.dataset.variantSolo;
        if (variantInput && variantId) {
          variantInput.value = variantId;
          console.log('✅ Variante mise à jour:', variantId, isDuo ? '(Duo)' : '(Solo)');
        }
      }

      // Mettre à jour la description de l'upload
      if (uploadDesc) {
        uploadDesc.textContent = isDuo
          ? 'Téléchargez une photo avec les deux personnes ensemble'
          : 'Téléchargez la photo qui deviendra une peluche unique';
      }
    }

    // Écouteurs pour le type Solo/Duo
    typeInputs.forEach(input => {
      input.addEventListener('change', updateVariantAndPrice);
    });

    // Écouteurs pour la taille
    sizeInputs.forEach(input => {
      input.addEventListener('change', updateVariantAndPrice);
    });

    // Initialisation
    updateVariantAndPrice();

    const setStatus = (msg, type = 'info') => {
      if (!statusEl) return;
      statusEl.textContent = msg;
      statusEl.className = `status-message ${type}`;
    };

    const setUploadStatus = (msg) => {
      if (uploadStatus) uploadStatus.textContent = msg;
    };

    const updateButtonState = () => {
      if (addBtn) addBtn.disabled = !chosenFile || isGenerating;
    };

    // Composition image
    function roundRectPath(ctx, x, y, w, h, r) {
      r = Math.max(0, Math.min(r, Math.min(w, h) / 2));
      ctx.beginPath();
      ctx.moveTo(x + r, y);
      ctx.lineTo(x + w - r, y);
      ctx.quadraticCurveTo(x + w, y, x + w, y + r);
      ctx.lineTo(x + w, y + h - r);
      ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
      ctx.lineTo(x + r, y + h);
      ctx.quadraticCurveTo(x, y + h, x, y + h - r);
      ctx.lineTo(x, y + r);
      ctx.quadraticCurveTo(x, y, x + r, y);
      ctx.closePath();
    }

    function drawContain(ctx, img, bx, by, bw, bh, pad = 0) {
      const iw = img.naturalWidth || img.width;
      const ih = img.naturalHeight || img.height;
      const s = Math.min((bw - 2 * pad) / iw, (bh - 2 * pad) / ih);
      const nw = iw * s, nh = ih * s;
      ctx.drawImage(img, bx + (bw - nw) / 2, by + (bh - nh) / 2, nw, nh);
    }

    async function loadImgSmart(src) {
      try {
        const i = new Image();
        i.crossOrigin = 'anonymous';
        await new Promise((res, rej) => { i.onload = res; i.onerror = rej; i.src = src; });
        return i;
      } catch {
        const r = await fetch(src, { mode: 'cors' });
        const b = await r.blob();
        const u = URL.createObjectURL(b);
        const i2 = new Image();
        await new Promise((res, rej) => { i2.onload = res; i2.onerror = rej; i2.src = u; });
        URL.revokeObjectURL(u);
        return i2;
      }
    }

    async function composeShareImage(origSrc, previewSrc) {
      const W = 1920, H = 1080;
      const canvas = document.createElement('canvas');
      canvas.width = W; canvas.height = H;
      const ctx = canvas.getContext('2d');

      ctx.fillStyle = '#A19CF2';
      ctx.fillRect(0, 0, W, H);

      const card = { x: 64, y: 64, w: W - 128, h: H - 220, r: 44 };
      ctx.fillStyle = '#e9e9ec';
      roundRectPath(ctx, card.x, card.y, card.w, card.h, card.r);
      ctx.fill();

      const gap = 48, pad = 48, rr = 28;
      const colW = (card.w - pad * 2 - gap) / 2;
      const colH = card.h - pad * 2;
      const L = { x: card.x + pad, y: card.y + pad, w: colW, h: colH };
      const R = { x: card.x + pad + colW + gap, y: card.y + pad, w: colW, h: colH };

      ctx.fillStyle = '#fff';
      roundRectPath(ctx, L.x, L.y, L.w, L.h, rr); ctx.fill();
      roundRectPath(ctx, R.x, R.y, R.w, R.h, rr); ctx.fill();

      const [imgB, imgA] = await Promise.all([loadImgSmart(origSrc), loadImgSmart(previewSrc)]);

      ctx.save(); roundRectPath(ctx, L.x, L.y, L.w, L.h, rr); ctx.clip();
      drawContain(ctx, imgB, L.x, L.y, L.w, L.h, 30); ctx.restore();

      ctx.save(); roundRectPath(ctx, R.x, R.y, R.w, R.h, rr); ctx.clip();
      drawContain(ctx, imgA, R.x, R.y, R.w, R.h, 30); ctx.restore();

      const pillY = card.y + card.h - 28;
      ctx.textAlign = 'center'; ctx.textBaseline = 'middle';

      function pill(cx, cy, text, accent = false) {
        ctx.font = '700 44px system-ui,-apple-system,sans-serif';
        const w = Math.ceil(ctx.measureText(text).width) + 84, h = 70;
        const x = cx - w / 2, y = cy - h / 2;
        if (accent) {
          ctx.fillStyle = '#6f56ef'; roundRectPath(ctx, x, y, w, h, 999); ctx.fill();
          ctx.fillStyle = '#fff'; ctx.fillText(text, cx, cy + 1);
        } else {
          ctx.fillStyle = '#fff'; ctx.strokeStyle = '#e7e7ee'; ctx.lineWidth = 2;
          roundRectPath(ctx, x, y, w, h, 999); ctx.fill(); ctx.stroke();
          ctx.fillStyle = '#6f56ef'; ctx.fillText(text, cx, cy + 1);
        }
      }

      pill(L.x + L.w / 2, pillY, 'Ma photo', false);
      pill(R.x + R.w / 2, pillY, 'Ma peluche', true);

      ctx.fillStyle = '#A19CF2';
      ctx.fillRect(0, H - 145, W, 145);

      try {
        const logo = await loadImgSmart('https://cdn.shopify.com/s/files/1/0889/8189/7558/files/Fichier_10_4x_a4cf3e5c-8ca3-445d-95ef-71653c743e37.png?v=1757189709');
        const scale = Math.min(460 / logo.width, 105 / logo.height);
        ctx.drawImage(logo, (W - logo.width * scale) / 2, H - 145 + (145 - logo.height * scale) / 2, logo.width * scale, logo.height * scale);
      } catch {}

      const blob = await new Promise(res => canvas.toBlob(res, 'image/jpeg', 0.92));
      return { blob, file: new File([blob], 'apercu-peluche.jpg', { type: 'image/jpeg' }) };
    }

    async function generateComposedPreview(origSrc, previewSrc) {
      const { blob } = await composeShareImage(origSrc, previewSrc);
      return URL.createObjectURL(blob);
    }

    async function generatePreview(file) {
      if (isGenerating) return;
      isGenerating = true;
      addBtn.classList.add('loading');
      addBtn.disabled = true;

      if (apSection) {
        apSection.hidden = false;
        apImg.hidden = true;
        apSkel.style.display = 'block';
        apShare.hidden = true;
        apDL.hidden = true;
      }

      if (apOrig && blobUrl) apOrig.src = blobUrl;
      setUploadStatus('🎨 Génération...');
      setStatus('Génération de votre aperçu personnalisé...', 'info');

      try {
        const formData = new FormData();
        formData.append('image', file, file.name || 'photo.jpg');

        const response = await fetch(WEBHOOK_URL, { method: 'POST', body: formData });
        const data = await response.json();

        let aperçuUrl = data.preview || data.preview_url || data.previewUrl || data.apercu || data.image_url || data.url;
        if (data.data) aperçuUrl = aperçuUrl || data.data.preview || data.data.preview_url;

        if (aperçuUrl) {
          previewUrl = aperçuUrl;
          const composedBlobUrl = await generateComposedPreview(blobUrl, aperçuUrl);
          
          apSkel.style.display = 'none';
          apImg.src = composedBlobUrl;
          apImg.hidden = false;
          apShare.hidden = false;
          apDL.hidden = false;
          apDL.dataset.preview = aperçuUrl;
          apDL.dataset.orig = blobUrl || '';
          apDL.dataset.composed = composedBlobUrl;

          setUploadStatus('✅ Aperçu prêt');
          setStatus('✨ Aperçu généré avec succès !', 'success');
          apSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          throw new Error('Pas d\'URL');
        }
      } catch (error) {
        console.error('❌', error);
        if (apSkel) apSkel.style.display = 'none';
        setUploadStatus('⚠️ Aperçu indisponible');
        setStatus('Aperçu indisponible, mais vous pouvez commander', 'error');
      } finally {
        isGenerating = false;
        addBtn.classList.remove('loading');
        updateButtonState();
      }
    }

    async function setPicked(file) {
      if (file.size > MAX_BYTES) { setStatus('Fichier trop lourd (max 10 Mo)', 'error'); return; }
      chosenFile = file;
      if (blobUrl) URL.revokeObjectURL(blobUrl);
      blobUrl = URL.createObjectURL(file);
      thumb.src = blobUrl;
      fileName.textContent = file.name;
      setUploadStatus('✓ Image chargée');
      emptyState.hidden = true;
      previewState.hidden = false;
      fileEl.style.display = 'none';
      updateButtonState();
      setStatus('Image chargée, génération de l\'aperçu...', 'info');
      await generatePreview(file);
    }

    function clearPicked() {
      chosenFile = null; previewUrl = null;
      if (fileEl) { fileEl.value = ''; fileEl.style.display = ''; }
      if (blobUrl) { URL.revokeObjectURL(blobUrl); blobUrl = null; }
      emptyState.hidden = false; previewState.hidden = true;
      if (apSection) apSection.hidden = true;
      updateButtonState(); setStatus('', 'info');
    }

    chooseBtn?.addEventListener('click', () => fileEl?.click());
    fileEl?.addEventListener('change', async () => { const f = fileEl.files?.[0]; if (f) { await setPicked(f); if (urlInput) urlInput.value = ''; } });
    uploadZone?.addEventListener('dragover', (e) => { e.preventDefault(); uploadZone.classList.add('dragover'); });
    uploadZone?.addEventListener('dragleave', () => uploadZone.classList.remove('dragover'));
    uploadZone?.addEventListener('drop', async (e) => {
      e.preventDefault(); uploadZone.classList.remove('dragover');
      const f = e.dataTransfer.files?.[0];
      if (f) { const dt = new DataTransfer(); dt.items.add(f); fileEl.files = dt.files; await setPicked(f); if (urlInput) urlInput.value = ''; }
    });
    clearBtn?.addEventListener('click', clearPicked);

    addBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      if (!chosenFile) { setStatus('Veuillez ajouter une photo', 'error'); return; }
      if (isGenerating) { setStatus('Génération en cours...', 'info'); return; }

      const mainForm = document.querySelector('form[data-type="add-to-cart-form"]');
      if (!mainForm) { setStatus('Erreur: formulaire non trouvé', 'error'); return; }

      try {
        let mainFileInput = mainForm.querySelector('input[name="properties[Image originale]"]');
        if (!mainFileInput) { mainFileInput = document.createElement('input'); mainFileInput.type = 'file'; mainFileInput.name = 'properties[Image originale]'; mainFileInput.style.display = 'none'; mainForm.appendChild(mainFileInput); }
        if (fileEl?.files?.[0]) { const dt = new DataTransfer(); dt.items.add(fileEl.files[0]); mainFileInput.files = dt.files; }

        const selectedType = document.querySelector('input[name="properties[Type]"]:checked');
        if (selectedType) { let typeInput = mainForm.querySelector('input[name="properties[Type]"]'); if (!typeInput) { typeInput = document.createElement('input'); typeInput.type = 'hidden'; typeInput.name = 'properties[Type]'; mainForm.appendChild(typeInput); } typeInput.value = selectedType.value; }

        const selectedSize = document.querySelector('input[name="properties[Taille]"]:checked');
        if (selectedSize) { let sizeInput = mainForm.querySelector('input[name="properties[Taille]"]'); if (!sizeInput) { sizeInput = document.createElement('input'); sizeInput.type = 'hidden'; sizeInput.name = 'properties[Taille]'; mainForm.appendChild(sizeInput); } sizeInput.value = selectedSize.value; }

        const notesTextarea = document.querySelector('textarea[name="properties[Notes]"]');
        if (notesTextarea?.value?.trim()) { let notesInput = mainForm.querySelector('input[name="properties[Notes]"]'); if (!notesInput) { notesInput = document.createElement('input'); notesInput.type = 'hidden'; notesInput.name = 'properties[Notes]'; mainForm.appendChild(notesInput); } notesInput.value = notesTextarea.value.trim(); }

        if (previewUrl) { let previewInput = mainForm.querySelector('input[name="properties[Aperçu généré (URL)]"]'); if (!previewInput) { previewInput = document.createElement('input'); previewInput.type = 'hidden'; previewInput.name = 'properties[Aperçu généré (URL)]'; mainForm.appendChild(previewInput); } previewInput.value = previewUrl; }

        const submitBtn = mainForm.querySelector('button[name="add"][type="submit"]');
        if (submitBtn) submitBtn.click(); else mainForm.requestSubmit();
      } catch (error) { console.error('❌', error); setStatus('Erreur technique', 'error'); }
    });

    apShare?.addEventListener('click', async () => {
      try {
        const origSrc = apDL?.dataset.orig || blobUrl;
        const previewSrc = apDL?.dataset.preview || previewUrl;
        if (!previewSrc || !origSrc) return;
        const { file } = await composeShareImage(origSrc, previewSrc);
        if (navigator.canShare?.({ files: [file] })) { await navigator.share({ title: 'Aperçu peluche', text: 'Regarde ma peluche ! 🧸', files: [file] }); }
        else { const a = document.createElement('a'); a.href = apImg?.src; a.download = 'apercu-peluche.jpg'; document.body.appendChild(a); a.click(); a.remove(); }
      } catch {}
    });

    apDL?.addEventListener('click', async (e) => {
      e.preventDefault();
      try {
        const composedUrl = apDL?.dataset.composed || apImg?.src;
        if (!composedUrl) return;

        // iOS Safari ne supporte pas bien le téléchargement via blob
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

        if (isIOS) {
          // Sur iOS, ouvrir l'image dans un nouvel onglet pour permettre l'enregistrement
          window.open(composedUrl, '_blank');
        } else {
          const response = await fetch(composedUrl);
          const blob = await response.blob();
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'apercu-peluche.jpg';
          document.body.appendChild(a);
          a.click();
          a.remove();
          URL.revokeObjectURL(url);
        }
      } catch {}
    });

    // Lightbox avec zoom
    const zoomContainer = document.getElementById('zoom-container');
    const zoomLens = document.getElementById('zoom-lens');
    const ZOOM_FACTOR = 2.5;
    let isMobile = window.matchMedia('(max-width: 639px)').matches;
    let currentScale = 1, startDistance = 0;

    function openLB(src) {
      if (!lb) return;
      lbImg.src = src; lb.hidden = false; document.body.style.overflow = 'hidden';
      currentScale = 1; if (lbImg) lbImg.style.transform = '';
      if (zoomLens && !isMobile) zoomLens.style.backgroundImage = `url(${src})`;
    }

    function closeLB() {
      if (!lb) return;
      lb.hidden = true; lbImg.removeAttribute('src'); document.body.style.overflow = '';
      if (zoomContainer) zoomContainer.classList.remove('zooming');
      currentScale = 1; if (lbImg) lbImg.style.transform = '';
    }

    apImg?.addEventListener('click', () => { if (apImg.src) openLB(apImg.src); });
    lbBackdrop?.addEventListener('click', closeLB);
    lbClose?.addEventListener('click', closeLB);
    window.addEventListener('keydown', (e) => { if (!lb?.hidden && e.key === 'Escape') closeLB(); });

    if (zoomContainer && zoomLens && !isMobile) {
      zoomContainer.addEventListener('mouseenter', () => zoomContainer.classList.add('zooming'));
      zoomContainer.addEventListener('mouseleave', () => zoomContainer.classList.remove('zooming'));
      zoomContainer.addEventListener('mousemove', (e) => {
        if (!zoomContainer.classList.contains('zooming') || !lbImg) return;
        const rect = lbImg.getBoundingClientRect();
        const x = e.clientX - rect.left, y = e.clientY - rect.top;
        const lensW = zoomLens.offsetWidth, lensH = zoomLens.offsetHeight;
        let lensX = Math.max(0, Math.min(x - lensW / 2, rect.width - lensW));
        let lensY = Math.max(0, Math.min(y - lensH / 2, rect.height - lensH));
        zoomLens.style.left = lensX + 'px'; zoomLens.style.top = lensY + 'px';
        zoomLens.style.backgroundSize = `${rect.width * ZOOM_FACTOR}px ${rect.height * ZOOM_FACTOR}px`;
        zoomLens.style.backgroundPosition = `${(x / rect.width) * 100}% ${(y / rect.height) * 100}%`;
      });
    }

    if (isMobile && lbImg) {
      let isPinching = false;
      const getDistance = (t) => Math.sqrt((t[0].clientX - t[1].clientX) ** 2 + (t[0].clientY - t[1].clientY) ** 2);
      lbImg.addEventListener('touchstart', (e) => { if (e.touches.length === 2) { isPinching = true; startDistance = getDistance(e.touches); e.preventDefault(); } }, { passive: false });
      lbImg.addEventListener('touchmove', (e) => { if (isPinching && e.touches.length === 2) { const d = getDistance(e.touches); currentScale = Math.min(4, Math.max(1, currentScale * (d / startDistance))); lbImg.style.transform = `scale(${currentScale})`; startDistance = d; e.preventDefault(); } }, { passive: false });
      lbImg.addEventListener('touchend', () => { isPinching = false; if (currentScale < 1.1) { currentScale = 1; lbImg.style.transform = ''; } });
      let lastTap = 0;
      lbImg.addEventListener('touchend', (e) => { const now = Date.now(); if (now - lastTap < 300 && e.changedTouches.length === 1) { if (currentScale > 1) { currentScale = 1; lbImg.style.transform = ''; } else { currentScale = 2; lbImg.style.transform = 'scale(2)'; } } lastTap = now; });
    }

    window.addEventListener('resize', () => { isMobile = window.matchMedia('(max-width: 639px)').matches; });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
